module.exports = __webpack_public_path__ + "img/Facebook-f_Logo-Blue-Logo.b41e78d4.svg";